import { BoxGeometry, Mesh, MeshBasicMaterial, Quaternion, Vector3 } from 'three';
import { ActionControllerEventName, ResourcesManager, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { CircleSliderComponent, SlidingMode } from '@verybigthings/vbt-webvr-framework/build/main/ts/components/CircleSliderComponent';
import IconButtonComponent from '@verybigthings/vbt-webvr-framework/build/main/ts/components/IconButtonComponent';
import * as styleConfig from '../../styleConfig';
export default class WaxModule extends ViewerModule {
    constructor(instruments, instrumentsPositions, table, pointerController, level, uiContainer) {
        super();
        this.__inited = false;
        this.waxActive = false;
        this.instruments = instruments;
        this.table = table;
        this.wax = instruments.wax;
        this.dish1Cap = instruments.dish1.getObjectByName('cap');
        this.instrumentsPositions = instrumentsPositions;
        this.pointerController = pointerController;
        this.uiContainer = uiContainer;
        this.level = level;
    }
    init() {
        this.wax = this.instruments.wax;
        this.dish1Cap = this.instruments.dish1.getObjectByName('cap');
        let callbackDish1;
        let waxOldPosition = this.instrumentsPositions.wax.clone();
        // INIT WAX PICK
        let waxHolder = this.waxHolder = new Mesh(new BoxGeometry(.6, 0.1, .6), new MeshBasicMaterial({ color: 0x00ff00 }));
        waxHolder.position.copy(waxOldPosition);
        waxHolder.position.y -= 0.01;
        waxHolder.visible = false;
        this.table.getObjectByName('ph_group').add(waxHolder);
        console.log('WAXING inited');
        this.actionController.on(ActionControllerEventName.click, this.wax, this.waxPickCallback = (event) => {
            if (!this.level.interaction)
                return;
            if (this.waxActive)
                return;
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            waxHolder.visible = true;
            this.waxActive = true;
            this.visibilityShadow(this.wax, false);
            if (!Viewer.controls.zController) {
                this.pointerController.setObject(this.wax);
            }
            else {
                this.level.lobby.app.zSpacePickingController.forcePickUp(this.wax, event.distance, event.ray.origin.clone().add(event.ray.direction.clone().multiplyScalar(0.3 * 0.99)), new Quaternion().setFromUnitVectors(new Vector3(0, 0, -1), event.ray.direction), 0);
            }
        });
        if (!Viewer.controls.zController) {
            this.actionController.on(ActionControllerEventName.click, waxHolder, (event) => {
                if (!this.level.interaction)
                    return;
                if (!this.waxActive || this.pointerController.currentPointerObjectName === 'wax')
                    return;
                this.visibilityShadow(this.wax, true);
                this.pointerController.setObject(null);
                // if (this.level.lobby.app.zSpacePickingController && Viewer.controls.zController) {
                //     this.level.lobby.app.zSpacePickingController.forceRelease();
                // }
                waxHolder.visible = false;
                this.waxActive = false;
                this.wax.position.copy(waxOldPosition);
                this.wax.rotation.set(0, 0, 0);
                this.table.add(this.wax);
            });
        }
        else {
            this.actionController.on(ActionControllerEventName.click, this.table, (event) => {
                if (!this.level.interaction)
                    return;
                if (!this.waxActive)
                    return;
                const distanceToAlcoHolder = this.wax.getWorldPosition(new Vector3()).distanceTo(this.waxHolder.getWorldPosition(new Vector3()));
                if (distanceToAlcoHolder < 0.7) {
                    this.visibilityShadow(this.wax, true);
                    this.pointerController.setObject(null);
                    this.level.lobby.app.zSpacePickingController.forceRelease();
                    waxHolder.visible = false;
                    this.waxActive = false;
                    this.wax.position.copy(waxOldPosition);
                    this.wax.rotation.set(0, 0, 0);
                    this.table.add(this.wax);
                }
            });
        }
        // DISH 1 CAP WAXING
        this.actionController.on(ActionControllerEventName.click, this.dish1Cap, callbackDish1 = () => {
            if (!this.level.interaction)
                return;
            if (this.waxActive) {
                ResourcesManager.getAudioManger().getAudio('wax_sound').play();
                this.actionController.off(ActionControllerEventName.click, this.dish1Cap, callbackDish1);
                this.actionController.off(ActionControllerEventName.click, this.wax, this.waxPickCallback);
                if (Viewer.controls.zController) {
                    this.level.uiContainer.add(this.waxApply.uiObject);
                    this.waxApply.uiObject.position.set(0, 0, 0);
                    this.waxApply.uiObject.rotation.set(0, 0, 0);
                    this.waxApply.uiObject.scale.setScalar(2);
                }
                else
                    this.uiContainer.add(this.waxApply.uiObject);
            }
        });
        this.waxApply = new CircleSliderComponent({
            mode: SlidingMode.onlyClockwise,
            diameter: 2.5,
            magnetOnSides: 0.05,
            spaceBetweenObjects: 0.02,
            picker: new IconButtonComponent({
                text: '',
                diameter: 0.6,
                background: styleConfig.SLIDER_PICKER_COLOR.getStyle(),
                textColor: styleConfig.SLIDER_PICKER_TEXT_COLOR.getStyle(),
            }),
            filledPart: {
                width: 0.35,
                mainColor: styleConfig.SLIDER_FILLED_COLOR
            },
            unfilledPart: {
                width: 0.35,
                border: 0.1,
                mainColor: styleConfig.SLIDER_UNFILLED_COLOR,
                borderColor: styleConfig.SLIDER_BORDER_COLOR
            }
        });
        this.waxApply.once('completed', () => {
            this.dish1Cap.add(ResourcesManager.getModel('petri_wax_on_cap').clone());
            this.fire('dish_waxed');
            this.waxApply.uiObject.visible = false;
            this.waxApply.dispose();
            let waxToTable;
            this.actionController.on(ActionControllerEventName.click, this.table, waxToTable = (event) => {
                if (!Viewer.controls.zController)
                    return;
                if (!this.level.interaction)
                    return;
                if (!this.waxActive)
                    return;
                const distanceToWaxHolder = this.wax.getWorldPosition(new Vector3()).distanceTo(waxHolder.getWorldPosition(new Vector3()));
                if (distanceToWaxHolder < 1.3) {
                    this.visibilityShadow(this.wax, true);
                    this.level.lobby.app.zSpacePickingController.forceRelease();
                    waxHolder.visible = false;
                    this.waxActive = false;
                    this.wax.position.copy(waxOldPosition);
                    this.wax.rotation.set(0, 0, 0);
                    this.table.add(this.wax);
                    this.actionController.off(ActionControllerEventName.click, this.table, waxToTable);
                }
            });
        });
        this.waxApply.uiObject.position.set(2.7, -1.78, 2.24);
        this.waxApply.uiObject.rotation.set(0, -.24, 0);
        this.waxApply.uiObject.userData.pcPosition = this.waxApply.uiObject.position.clone();
        this.waxApply.uiObject.userData.pcRotation = this.waxApply.uiObject.rotation.clone();
    }
    visibilityShadow(el, visibility = true) {
        const pPlane = el.getObjectByName('pPlane');
        if (pPlane)
            pPlane.visible = visibility;
    }
    reset() {
        this.dish1Cap && (this.dish1Cap.visible = false);
        this.wax && (this.wax.visible = false);
        // this.actionController.off(null, this.wax);
        this.waxHolder && (this.waxHolder.visible = false);
    }
    update() {
    }
}
